import { render } from "./Dispute.vue?vue&type=template&id=088ad526&scoped=true"
import script from "./Dispute.vue?vue&type=script&lang=js"
export * from "./Dispute.vue?vue&type=script&lang=js"

import "./Dispute.vue?vue&type=style&index=0&id=088ad526&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-088ad526"]])

export default __exports__